import { EventEmitter, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, catchError, concatMap, delay, map, Observable, of, retryWhen, Subscription, take, throwError } from "rxjs";
import Swal from 'sweetalert2'
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import { ValidationErrors } from "@angular/forms";
import { prefixes } from 'libs/shared/src/lib/models/prefixes';
import { MatDialog } from "@angular/material/dialog";
import { ImpressumModal } from "../components/impressum-dialog/impressum-dialog.component";
import { ConsentsModal } from "../components/consents-dialog/consents-dialog.component";

@Injectable()

export class HelpersService {

    public storageLangKey = 'vfa-cp-storage-lang';
    public storageRenewalTokenKey = 'vfa-cp-storage-renewal-token';
    public storageAccessTokenKey = 'vfa-cp-storage-access-token';
    private storageRefreshTokenKey = 'vfa-cp-storage-refresh-token';
    private storageExpiresInKey = 'vfa-cp-storage-expires-in';
    public storageAssetIdKey = 'vfa-cp-storage-asset-id';
    public storageOrderIdKey = 'vfa-cp-storage-order-id';
    private storageConfigKey = "vfa-cp-storage-config";
    private storagePolishProvincesKey = "vfa-cp-storage-polish-provinces";
    private storagePKCEKey = "vfa-cp-storage-pkce";
    private storageLastVisitKey = "vfa-cp-storage-last-visit";
    public storageDiscountKey = "vfa-cp-storage-discount";
    public storageMaintenanceMessageKey = "vfa-cp-maintenance-message";

    // CONSTANTS
    public API_VERSION = "v3";

    public STATE_MACHINE = 'onboarding-customer';
    public STATE_MACHINE_DEFAULT = 'onboarding-customer';
    public STATE_MACHINE_B2B = 'onboarding-customer-b2b';
    public STATE_MACHINE_B2C = 'onboarding-customer-b2c';

    public codePKCE: any = {};
    public _refreshToken$: Subscription = new Subscription;
    public timeoutRefresh: any = null;
    public startLoginProcess = false;
    public translationObj = new BehaviorSubject({});
    public prefixes = prefixes;
    public emailRegex = /^[a-zA-Z\d]+([._-]{1}[a-zA-Z\d]+)*\@[a-zA-Z\d]+([.-]{1}[a-zA-Z\d]+)*\.[a-zA-Z]{2,}$/;
    public nameRegex = /^[^£$%&€;:_°#§*+\]\[^\d^?=)(\/\!|\"\\]+$/;

    public paymentInformation = null;

    public languages: any[] = [];
    public translated = new BehaviorSubject(false);
    public defaultLangCode = "en_GB";
    public headerLang: any;
    public headerLangClicked: boolean = false;

    public nspObj: any;
    private putUserStateSubscription$: Subscription = new Subscription;
    public consentsIds: string[] = [];

    public userInfo: any;

    //Header Variables
    public navigateTo: any;
    public arrowIcon: any;
    public notHelp: any;
    public headerType: any;
    public bell: any;
    public navLogo: any;
    public noFooter: any;
    public isHome: any;
    public isRenewal: any;
    public isLegacy: any;
    public notWizard: any;

    public originalConfigsFlow = [
        { pos: 0, label: 'Landing from CRM E-mail', path: '/auth/first-login', disabled: true },
        { pos: 1, label: 'Welcome', path: '/auth/welcome' },
        { pos: 2, label: 'OTP process', path: '/auth/send-otp' },
        { pos: 3, label: 'Terms Acceptance', path: '/auth/terms-acceptance' },
        { pos: 4, label: 'Choose password', path: '/auth/choose-password' },

        { pos: 5, label: 'Personal info', path: '/orders/personal-info' },
        { pos: 6, label: 'Security questions', path: '/orders/security-questions' },
        { pos: 7, label: 'Your pending orders', path: '/orders/your-orders' },
        { pos: 8, label: 'Vehicle information', path: '/orders/vehicle-info' },
        { pos: 9, label: 'Contract selection', path: '/orders/contract' },
        { pos: 10, label: 'Contract terms', path: '/orders/contract-terms' },
        { pos: 11, label: 'Contract payment', path: '/orders/contract-payment' }
    ];

    public initialProcessFlow = { routes: [
        { pos: 1, label: 'Welcome', path: '/auth/welcome' },
        { pos: 2, label: 'OTP process', path: '/auth/send-otp' },
        // { pos: 3, label: 'Terms Acceptance', path: '/auth/terms-acceptance' },
        { pos: 4, label: 'Choose password', path: '/auth/choose-password' }
    ]}

    public ordersProcessFlow = { routes: [
        { path: '/orders/personal-info', state: 'INITIAL' },
        { path: '/orders/security-questions', state: 'PERSONAL_INFO' },
        // { path: '/orders/your-orders', state: 'SECURITY_QUESTIONS' }
    ]}

    public recoveryProcessFlow = [
        {
            machine: 'onboarding-customer', routes: [
                { path: '/orders/personal-info', state: 'INITIAL' },
                { path: '/orders/security-questions', state: 'PERSONAL_INFO' },
                { path: '/orders/your-orders', state: 'SECURITY_QUESTIONS' },
            ]
        },
        {
            machine: 'onboarding-customer-b2b', routes: [
                { path: '/details/orders/vehicle-info', state: 'ORDERS', rebackOrders: true },
                { path: '/details/orders/contract-terms', state: 'SERVICE_DURATION' },
                { path: '/details/orders/contract-insurance', state: 'INSURANCE' },
                { path: '/dashboard', state: 'ONBOARDING_FINAL' }
            ]
        },
        {
            machine: 'onboarding-customer-b2c', routes: [
                { path: '/details/orders/vehicle-info', state: 'ORDERS', rebackOrders: true },
                { path: '/details/orders/contract', state: 'VEHICLE_INFORMATION' },
                { path: '/details/orders/contract-terms', state: 'SERVICE_DURATION' },
                { path: '/details/orders/contract-payment', state: 'SERVICE_TERMS' },
                { path: '/details/orders/contract-insurance', state: 'INSURANCE' },
                { path: '/dashboard', state: 'ONBOARDING_FINAL' }
            ]
        }
    ];

    public renewalProcessFlow = { routes: [
        { path: '/renewal/contract', state: 'VEHICLE_INFORMATION' },
        { path: '/renewal/contract-payment', state: 'SERVICE_TERMS' }
    ]}

    public recoveryProcessFlowV1 = [
        { path: '/orders/personal-info', state: 'INITIAL' },
        { path: '/orders/security-questions', state: 'PERSONAL_INFO' },
        { path: '/orders/your-orders', state: 'SECURITY_QUESTIONS' },
        { path: '/details/orders/vehicle-info', state: 'ORDERS', rebackOrders: true },
        { path: '/details/orders/contract', state: 'VEHICLE_INFORMATION' },
        { path: '/details/orders/contract-terms', state: 'SERVICE_DURATION' },
        { path: '/dashboard', state: 'ONBOARDING_FINAL' }
    ];

    constructor(protected router: Router,
        protected http: HttpClient,
        protected translate: TranslateService,
        private dialog: MatDialog) {
        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this.setLanguage(event.lang);
            this.translationObj.next(event.translations);
        });
        this.translate.use(this.lang)
    }

    get isMobile(): boolean {
        return /Mobile|iP(hone|od|ad)|Android|Samsung|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/.test(navigator.userAgent);
    }

    get lastVisit(): any {
        return localStorage.getItem(this.storageLastVisitKey);
    }

    public saveLastVisit(pathname: string) {
        localStorage.setItem(this.storageLastVisitKey, pathname);
    }

    public backToLastVisit() {
        this.router.navigateByUrl(this.lastVisit);
        localStorage.removeItem(this.storageLastVisitKey);
    }

    get lang(): any {
        return localStorage.getItem(this.storageLangKey);
    }

    get langsCode(): string[] {
        const ret = [];
        for (const lang of this.languages) {
            ret.push(lang.value);
        }
        return ret;
    }

    getCroppedLang(fullCode: string) {
        return fullCode.substring(0, 2);
    }

    setLanguage(lang: string): void {
        this.searchHeaderLanguage(lang);
        localStorage.setItem(this.storageLangKey, lang);
        document.documentElement.lang = localStorage.getItem('vfa-cp-storage-lang')!.replace('_','-');
    }

    public useLanguage(langCode: string) {
        this.translate.use(langCode).subscribe(res => {
            this.translated.next(true);
        }, err => {
            this.translated.next(true);
        });
        this.setLanguage(langCode);
    }

    public existLang(languages: any, lang: string): boolean {
        let ret = false;
        const langReplaced = lang.replace("-", "_");
        for (const language of languages) {
            if (language.value.includes(langReplaced)) {
                ret = true;
                return ret;
            }
        }
        return ret;
    }

    public searchSelectedLanguage(lang: any) {
        this.headerLangClicked = false;
        this.searchHeaderLanguage(lang);
        this.translate.use(this.headerLang.value).subscribe(res => {
          this.setLanguage(this.headerLang.value);
          setTimeout(() => {this.eventToImpressum();}, 100);
        }, err => {
          this.showToast(this.getError(err), 'danger');
        });
    }

    get config(): any {
        const config = localStorage.getItem(this.storageConfigKey);
        return config ? JSON.parse(config) : null;
    }

    get polishProvinces(): any {
        const polishProvinces = localStorage.getItem(this.storagePolishProvincesKey);
        return polishProvinces ? JSON.parse(polishProvinces) : null;
    }

    get pkce(): any {
        const obj = localStorage.getItem(this.storagePKCEKey);
        return obj ? JSON.parse(obj) : null;
    }

    public isAuthRoute(path: string): boolean {
        return path.includes('/auth/')
    }

    public checkUserState(): void {
        if (!this.isAuthRoute(window.location.pathname)) {
            const accessTokenHasExpired = this.hasExpired(this.storageExpiresIn);
            if (!accessTokenHasExpired) {
                this.startRefreshInterval();
            } else if (this.storageAccessToken) {
                this.callRefreshTokenOauth();
            }
        }
    }

    public getUserState(): Observable<any> {
        return this.http.get(`${this.config.BASEURL_ORDER_API}/v1/secured/processes/onboarding-customer`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                this.consentsIds = res.data.consentsIds;
                return res;
            }),
            catchError(error => {
                return error;
            })
        )
    }

    public putUserState(currentState: string, data: any): Observable<any> {
        if(!data.consentsIds?.length) {
            data = { ...data, consentsIds: this.consentsIds }
        }
        const req: any = {
            state: currentState,
            data
        }
        return this.http.put(`${this.config.BASEURL_ORDER_API}/v1/secured/processes/onboarding-customer`, req, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return error;
            })
        )
    }

    public updateCurrentState(currentState: string, data: any) {
        const flow = this.recoveryProcessFlow.filter(e => e.machine === data.machine)[0];
        const route = flow.routes.filter(e => e.state === currentState)[0];
        if (this.putUserStateSubscription$ instanceof Subscription) {
            this.putUserStateSubscription$.unsubscribe();
        }
        this.putUserStateSubscription$ = this.putUserState(currentState, data).subscribe(res => {
            let path = route.path;
            if(data && data.id) {
                path += "?order_id=" + data.id;
            }
            this.router.navigateByUrl(path);
        }, err => {
            return err;
        });
    }

    public updateUserState(currentState: string, data: any, redirectTo?: string): void {
        if (this.putUserStateSubscription$ instanceof Subscription) {
            this.putUserStateSubscription$.unsubscribe();
        }
        this.putUserStateSubscription$ = this.putUserState(currentState, data).subscribe(res => {
            const flow = this.recoveryProcessFlow.filter(e => e.machine === data.machine)[0];
            const found = flow.routes.filter(e => e.state === res.state)[0];
            let path = '';
            if (found) {
                this.STATE_MACHINE = data.machine;
                if (redirectTo) {
                    this.router.navigateByUrl(redirectTo);
                }
                path = found.path;
                if (res.data && res.data.id) {
                    if (data.machine === this.STATE_MACHINE_DEFAULT) {
                        path += '/' + res.data.id;
                    } else {
                        path += '?order_id=' + res.data.id;
                    }
                }
                this.router.navigateByUrl(path);
            } else {
                this.searchRightMachine(currentState, data, redirectTo);
            }
        }, err => {
            this.router.navigateByUrl("/orders/personal-info");
        });
    }

    private searchRightMachine(currentState: string, data: any, redirectTo?: string) {
        const flow = this.recoveryProcessFlow.filter(e => e.machine === data.machine)[0];
        const found = flow.routes.filter(e => e.state === currentState)[0];
        if(found) {
            this.updateUserState(currentState, data, redirectTo);
        } else {
            for(let flow of this.recoveryProcessFlow) {
                for(let route of flow.routes) {
                    if(route.state === currentState) {
                        data.machine = flow.machine;
                        this.searchRightMachine(currentState, data, redirectTo);
                    }
                }
            }

        }
    }

    public getNSPToken(token: string | null): Observable<any> {
        return this.http.get(`${this.config.BASEURL_ACCOUNT_API}/v2/enrollment/nsp?token=${token}`, this.getHTTPHeader()).pipe(
            map((res: any) => {
                this.nspObj = res;
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public getNSP(): Observable<any> {
        return this.http.get(`${this.config.BASEURL_ORDER_API}/v1/secured/customer/nsp`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                this.nspObj = res;
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    // private redirectBasedOnNSP() {
    //     this.getNSP().subscribe(res => {
    //         if (res.onBoardingCompleted) {
    //             this.router.navigateByUrl('/dashboard');
    //         } else {
    //             this.router.navigateByUrl('/orders/personal-info');
    //         }
    //     }, err => {
    //         this.router.navigateByUrl('/orders/personal-info');
    //     });
    // }

    private fallbackCheckUserState(isError: boolean = false, hasAccount: boolean = true) {
        let data = {
            machine: this.STATE_MACHINE_DEFAULT
        };
        let state = "INITIAL";

         this.getPendingOrders().subscribe(res => {
            if(res && res.records && res.records.length){
                const found = res.records.filter((el: { Fallback_journey__c: any; }) => el.Fallback_journey__c)
                switch(true){
                    case((isError && !hasAccount) || (isError && !found.length)):
                        this.updateUserState(state, data)
                        break;
                    default:
                        if (res && res.records && res.records.length) {
                            state = "SECURITY_QUESTIONS";
                        } else {
                            state = "ONBOARDING_FINAL";
                            data.machine = this.STATE_MACHINE_B2C;
                        }
                        this.updateUserState(state, data);
                        break;
                }
            } else {
                if(hasAccount) {
                    state = "ONBOARDING_FINAL";
                    data.machine = this.STATE_MACHINE_B2C;
                }
                this.updateUserState(state, data);
            }
        });
    }

    public showUncheckedIdSwal() {
        const data = {
            machine: this.STATE_MACHINE_B2B
        };
        if (this.putUserStateSubscription$ instanceof Subscription) {
            this.putUserStateSubscription$.unsubscribe();
        }
        this.putUserStateSubscription$ = this.putUserState("ONBOARDING_FINAL", data).subscribe(res => {
            const title =this.translate.instant("not-pending-orders");
            const text = this.translate.instant("modal-not-pending-orders-message");
            const confirm = this.translate.instant("order-confirmation-cta");
            this.showSwal(title, text, true, confirm, false, "/dashboard");
        }, err => {
            const title =this.translate.instant("not-pending-orders");
            const text = this.translate.instant("modal-not-pending-orders-message");
            const confirm = this.translate.instant("order-confirmation-cta");
            this.showSwal(title, text, true, confirm, false, "/dashboard");
        });
    }

    public retrieveOrderId(id: any) {
        this.getPendingOrders().subscribe((res: any) => {
            const found = res.records.filter((el: any) => el.NE__OrderId__r.Id === id);
            if(!found) {
                this.showUncheckedIdSwal();
                return;
            }
        }, err => {
            this.showUncheckedIdSwal();
            return;
        })
    }

    private retUserStateV1(res: any, param?: any) {
        const found = this.recoveryProcessFlowV1.filter(e => e.state === res.state)[0];
        let path = '';
        if (found) {
            path = found.path;
            if (res.data && res.data.id) {
                path += '?order_id=' + res.data.id;
                this.router.navigateByUrl(path);
            }
            this.router.navigateByUrl(path);
        } else {
            this.fallbackCheckUserState();
        }
    }

    public retUserState(param?: any, hasAccount: boolean = true): void {
        this.getUserState().subscribe(res => {
            this.openConsentsModal(res);
            switch (res.state) {
                case "ONBOARDING_FINAL":
                    this.fallbackCheckUserState(false, hasAccount);
                    break;
                default:
                    this.onRetUserState(res, param ? param : null);
                    break;
            }
        }, err => {
            this.fallbackCheckUserState(true, hasAccount);
        })
    }

    private onRetUserState(res: any, param?: any) {
        if(param) {
            this.retrieveOrderId(param);
        }
        if (!res.data.machine) {
            this.retUserStateV1(res, param);
            return;
        }
        const flow = this.recoveryProcessFlow.filter(e => e.machine === res.data.machine)[0];
        const found = flow.routes.filter(e => e.state === res.state)[0];
        let path = '';
        if (found) {
            path = found.path;
            this.STATE_MACHINE = res.data.machine;
            if (res.data && res.data.id) {
                if (res.data.machine !== this.STATE_MACHINE_DEFAULT) {
                    path += '?order_id=' + res.data.id;
                    this.router.navigateByUrl(path);
                }
            }
            this.router.navigateByUrl(path);
        } else {
            this.fallbackCheckUserState();
        }
    }

    public putAndRedirectState(currentState: string, currentData: any, path: string) {
        this.putUserState(currentState, currentData).subscribe(res => {
            this.router.navigateByUrl(path);
            return;
        }, err => {
            this.router.navigateByUrl(path);
            return;
        });
    }

    private rebackToState(state: string) {
        this.STATE_MACHINE = this.STATE_MACHINE_DEFAULT;
        let currentData = {
            id: null,
            machine: this.STATE_MACHINE_DEFAULT,
            model: null
        };
        let flow: any = this.recoveryProcessFlow.filter(e => e.machine === this.STATE_MACHINE_DEFAULT)[0];
        let currentState = flow.routes.filter((route: any) => route.state === state)[0];
        this.putAndRedirectState(currentState.state, currentData, currentState.path);
    }

    private saveCurrentData(res: any, currentState: string, path: string) {
        let model: string = "";
        let currentData: any = null;
        if (res.data.id) {
            this.getVehicleInfo(res.data.id).subscribe(response => {
                if (response && response.Dealer__r && response.Dealer__r.Business_Model__c && response.Dealer__r.Business_Model__c === "B2C") {
                    model = this.STATE_MACHINE_B2C;
                } else if (response && response.Dealer__r && response.Dealer__r.Business_Model__c && response.Dealer__r.Business_Model__c === "B22") {
                    model = this.STATE_MACHINE_B2B;
                }
                currentData = { machine: model, id: res.data.id };
                this.putAndRedirectState(currentState, currentData, path);
            }, err => {
                this.fallbackCheckUserState(true);
            })
        } else {
            model = this.STATE_MACHINE_DEFAULT;
            currentData = { machine: model, id: null };
            this.putAndRedirectState(currentState, currentData, path);
        }
    }

    private undoUserStateV1(res: any) {
        let i = 0;
        for (let flow of this.recoveryProcessFlowV1) {
            if (flow.state === res.state) {
                break;
            }
            i = i + 1;
        }
        if (this.recoveryProcessFlowV1[i].rebackOrders) {
            this.getPendingOrders().subscribe(res => {
                if (res.records && res.records.length && res.records.length === 1) {
                    this.rebackToState("PERSONAL_INFO");
                    return;
                } else if(res.records && res.records.length && res.records.length > 1) {
                    this.rebackToState("SECURITY_QUESTIONS");
                    return;
                }
            }, err => { });
        } else if (i > 0) {
            let currentState = this.recoveryProcessFlowV1[i - 1].state;
            let path = this.recoveryProcessFlowV1[i - 1].path;
            if (res.data.id) {
                path += "?order_id=" + res.data.id;
            }
            this.saveCurrentData(res, currentState, path);
        }
    }

    public undoUserState(): void {
        this.getUserState().subscribe(res => {
            if (res) {
                if (!res.data.machine) {
                    this.undoUserStateV1(res);
                    return;
                }
                let found: boolean = false;
                let i: number = 0;
                let flow: any = this.recoveryProcessFlow.filter(e => e.machine === res.data.machine)[0];
                for (let route of flow.routes) {
                    if (route.state === res.state && i > 0) {
                        found = true;
                        this.STATE_MACHINE = res.data.machine;
                        let path = flow.routes[i - 1].path;
                        if (res.data && res.data.id) {
                            path += "?order_id=" + res.data.id;
                        }
                        let currentState = flow.routes[i - 1].state;
                        this.putAndRedirectState(currentState, res.data, path);
                    } else if (route.state === res.state && i === 0 && res.data.machine !== this.STATE_MACHINE_DEFAULT) {
                        found = true;
                        if (route.rebackOrders) {
                            this.getPendingOrders().subscribe(res => {
                                if (res.records && res.records.length && res.records.length === 1) {
                                    this.rebackToState("PERSONAL_INFO");
                                    return;
                                } else if(res.records && res.records.length && res.records.length > 1) {
                                    this.rebackToState("SECURITY_QUESTIONS");
                                    return;
                                }
                            }, err => { });
                        } else {
                            this.STATE_MACHINE = this.STATE_MACHINE_DEFAULT;
                            flow = this.recoveryProcessFlow.filter(e => e.machine === this.STATE_MACHINE_DEFAULT)[0];
                            let path = flow.routes[flow.routes.length - 1].path;
                            let currentState = flow.routes[flow.routes.length - 1].state;
                            let currentData = {
                                id: null,
                                machine: this.STATE_MACHINE_DEFAULT,
                                model: null
                            };
                            this.putAndRedirectState(currentState, currentData, path);

                        }
                    } else if (route.state === res.state && i === 0 && res.data.machine === this.STATE_MACHINE_DEFAULT) {
                        found = true;
                        this.STATE_MACHINE = this.STATE_MACHINE_DEFAULT;
                        let path = flow.routes[i].path;
                        let currentState = flow.routes[i].state;
                        let currentData = {
                            id: null,
                            machine: this.STATE_MACHINE_DEFAULT,
                            model: null
                        };
                        this.putAndRedirectState(currentState, currentData, path);
                    }
                    i = i + 1;
                }
                if (!found) {
                    history.back();
                }
            } else {
                history.back();
            }
        }, err => {
            history.back();
        })
    }

    private openConsentsModal(machineData: any) {
        this.getLastConsents().subscribe((res: any) => {
            if(res.data?.length) {
                const consentsData = res.data.map((el: any) => el.id);
                const notSignedConsents = res.data.filter((el: any) => !el.signedAt).map((el: any) => el.id);
                const filteredNotSignedConsents = notSignedConsents.filter((item: string) => !machineData?.data?.consentsIds?.includes(item));
                if(consentsData.length && notSignedConsents.length && (!machineData?.data?.consentsIds?.length || filteredNotSignedConsents.length)) {
                    this.dialog.open(ConsentsModal, {disableClose: true, panelClass: 'consents-dialog-container', data: {consentsIds: consentsData, ...machineData}});
                }
            }
        }, (err: any) => {})
    }

    public getLastConsents() {
        return this.http.get(`${this.config.BASEURL_ORDER_API}/v1/secured/assets/documents/latest`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public getOrders() {
        return this.http.get(`${this.config.BASEURL_ORDER_API}/v1/secured/orders?pending=false`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public getPendingOrders() {
        return this.http.get(`${this.config.BASEURL_ORDER_API}/v1/secured/orders?pending=true`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public getVehicleInfo(orderId: string) {
        return this.http.get(`${this.config.BASEURL_ORDER_API}/v1/secured/orders/${orderId}/details`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public getCheckoutInfo(orderId: string) {
        return this.http.get(`${this.config.BASEURL_ORDER_API}/v1/secured/orders/${orderId}/details-checkout`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                if (!res.is_price_synced) throw new Error("price-not-synced-error");
                return res;
            }),
            retryWhen(errors => errors.pipe(
                concatMap((e, i) =>
                    i < this.config.PAYMENT_MAX_RETRIES || this.config.PAYMENT_MAX_RETRIES === 0 ? of(e).pipe(delay(this.config.PAYMENT_RETRY_DELAY_MS)) : throwError("price-not-synced-error"),
                )
            )),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public hasExpired(expireDate: any): boolean {
        let ret = true;
        if (expireDate) {
            const todayDate = new Date().valueOf();
            ret = expireDate > todayDate ? false : true;
        }
        return ret;
    }

    public searchHeaderLanguage(lang: any) {
        let found = this.languages.filter(language => language.value === lang)[0];
        if(found) {
        this.headerLang = found;
        } else {
        found = this.languages.filter(language => language.value.includes(lang))[0];
            if(found) {
                this.headerLang = found;
            } else {
                this.headerLang = this.languages.filter(language => language.value === "en_GB")[0];
            }
        }
    }

    public setLanguageWebapp() {
        this.getLanguages().subscribe(res => {
            this.languages = res;
            for(let l of this.languages) {
                l.stateCode = l.value.split("_")[1];
                l.lang = l.label.split(" ")[0];
            }
            const savedlang = this.lang;
            const browserLang: any = navigator.language;
            const existLang = this.existLang(this.languages, browserLang);
            this.translate.addLangs(this.langsCode);
            let lang = this.defaultLangCode;
            if (savedlang) {
                lang = savedlang;
            } else if (browserLang && existLang) {
                const browserLangReplaced = browserLang.replace("-", "_");
                lang = browserLangReplaced;
            }
            this.useLanguage(lang);
        }, (err: any) => {
            this.useLanguage(this.defaultLangCode);
        })
    }

    public getLanguages(): Observable<any> {
        if (this.languages && this.languages.length) {
            return of(this.languages);
        }
        return this.http.get(`${this.config.BASEURL_SETTINGS_API}/v1/translation/languages`, this.getHTTPHeader()).pipe(
            map((res: any) => {
                this.languages = res;
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public instant(key: any, params?: any): string {
        return this.translate.instant(key, params ?? null);
    }

    get storageRenewalToken(): any {
        return sessionStorage.getItem(this.storageRenewalTokenKey);
    }

    get storageAccessToken(): any {
        return localStorage.getItem(this.storageAccessTokenKey);
    }

    get storageRefreshToken(): any {
        return localStorage.getItem(this.storageRefreshTokenKey);
    }
    
    get storageExpiresIn(): any {
        return Number(localStorage.getItem(this.storageExpiresInKey));
    }
    
    get storageSessionAccessToken(): any {
        return sessionStorage.getItem(this.storageAccessTokenKey);
    }

    get storageSessionAssetId(): any {
        return sessionStorage.getItem(this.storageAssetIdKey);
    }

    get storageSessionOrderId(): any {
        return sessionStorage.getItem(this.storageOrderIdKey);
    }

    public saveAccessToken(res: any) {
        localStorage.setItem(this.storageAccessTokenKey, res.access_token);
        if( res.refresh_token) {
            localStorage.setItem(this.storageRefreshTokenKey, res.refresh_token);
            const expiresIn = String(
                new Date().valueOf() + res.expires_in * 0.95 * 1000
            );
            localStorage.setItem(this.storageExpiresInKey, expiresIn);
        }
    }

    public saveSessionRenewalToken(res: any) {
        sessionStorage.setItem(this.storageRenewalTokenKey, res);
    }

    public saveSessionAccessToken(res: any) {
        sessionStorage.setItem(this.storageAccessTokenKey, res.accessToken);
        sessionStorage.setItem(this.storageAssetIdKey, res.rootAssetId);
    }

    public startRefreshInterval() {
        if (this.storageExpiresIn) {
            let interval = this.storageExpiresIn - new Date().valueOf();
            interval = interval < 0 ? 0 : interval;
            clearTimeout(this.timeoutRefresh);
            this.timeoutRefresh = setTimeout(() => {
                this.callRefreshTokenOauth();
            }, interval);
        } else if (this.storageAccessToken) {
            this.logout();
        }
    }

    private callRefreshTokenOauth() {
        if (!this.config.OAUTH_REFRESH_TOKEN_ENABLED) {
            return;
        }
        if (this._refreshToken$ instanceof Subscription) {
            this._refreshToken$.unsubscribe();
        }
        this._refreshToken$ = this.refreshToken().subscribe(res => {
            this.saveAccessToken(res);
            clearTimeout(this.timeoutRefresh);
            this.startRefreshInterval();
        }, err => {
            this.logout();
        });
    }

    public refreshToken() {
        const req = {
            grant_type: 'refresh_token',
            refresh_token: this.storageRefreshToken,
            client_id: this.config.OAUTH_CLIENT_ID
        }
        const params = new URLSearchParams(req);
        let headers = {};
        if(this.config.APIGEE_API_KEY) {
            headers = {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
                .set('Accept', 'application/ld+json')
                .set('apiKey',  this.config.APIGEE_API_KEY)
            };
        } else {
            headers = {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
                .set('Accept', 'application/ld+json')
            };
        }
        return this.http.post(`${this.config.BASEURL_AUTH_API}/oauth2/token`, params, headers).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public handleError(error: Response, isAutomotive: boolean = false) {
        if(!isAutomotive) {
            switch (error.status) {
                case 401:
                    if(this.storageRenewalToken) {
                        this.router.navigateByUrl("/automotive/renewal/auth")
                    } else {
                        this.logout();
                    }
                    break;
                case 408:
                    if(this.userInfo && this.userInfo.token_email && this.isAuthRoute(window.location.pathname)) {
                        const redirect = '/auth/first-login?details=' + this.userInfo.token_email;
                        this.showToast(this.getError(error), 'danger', redirect);
                    }
                    break;
                // case 500:
                //     this.router.navigateByUrl("core/error/error");
                //     break;
            }
        }
        return throwError(error);

    }

    public getHTTPHeader(isAuth?: boolean): { headers: HttpHeaders } {
        const token: string = this.storageAccessToken || this.storageSessionAccessToken;
        const config = this.config;
        const headersObj: Record<string, string> = {};
        
        if (!isAuth || !token) {
            headersObj['Content-Type'] = 'application/json';
            headersObj['Accept'] = 'application/ld+json';
        } else {
            headersObj['Authorization'] = `Bearer ${token}`;
            headersObj['Content-Type'] = 'application/json';
            headersObj['Accept'] = 'application/ld+json';
        }
        
        if (config && config.APIGEE_API_KEY) {
            headersObj['apiKey'] = config.APIGEE_API_KEY;
        }
        
        const httpHeaders = new HttpHeaders(headersObj);
        return { headers: httpHeaders };
    }

    public getHTTPHeaderPDF(isAuth?: boolean): { headers: HttpHeaders, responseType: 'arraybuffer' } {
        const token: string = this.storageAccessToken;
        const config = this.config;
        const headersObj: Record<string, string> = {};
        
        if (!isAuth || !token) {
            headersObj['Content-Type'] = 'application/json';
        } else {
            headersObj['Authorization'] = `Bearer ${token}`;
            headersObj['Content-Type'] = 'application/json';
        }
        
        if (config && config.APIGEE_API_KEY) {
            headersObj['apiKey'] = config.APIGEE_API_KEY;
        }
        
        const httpHeaders = new HttpHeaders(headersObj);
        return { headers: httpHeaders, responseType: 'arraybuffer' as 'arraybuffer' };
    }

    public clearSessionStorage() {
        console.log('clear session storage');
        sessionStorage.removeItem(this.storageRenewalTokenKey);
        sessionStorage.removeItem(this.storageAccessTokenKey);
        sessionStorage.removeItem(this.storageAssetIdKey);
        sessionStorage.removeItem(this.storageOrderIdKey);
    }

    public clearStorage() {
        console.log('clear storage');
        localStorage.removeItem(this.storageAccessTokenKey);
        localStorage.removeItem(this.storageRefreshTokenKey);
        localStorage.removeItem(this.storageExpiresInKey);
        localStorage.removeItem(this.storagePKCEKey);

        this.clearSessionStorage();
    }

    public logout() {
        // this.clearStorage();
        // this.login();
        this.logoutIAM();
    }

    public logoutIAM() {
        this.clearStorage();
        window.open(this.config.OAUTH_LOGOUT_URL, '_self');
    }

    public login(forced = false) {
        if (!this.isAuthRoute(window.location.pathname) || forced) {
            this.startLoginProcess = true;
            this.codePKCE = {};
            this.codePKCE.code_verifier = this.generateCodeVerifier();
            this.generateCodeChallenge(this.codePKCE.code_verifier);
        }
    }

    generateCodeVerifier() {
        // GENERATING CODE VERIFIER
        function dec2hex(dec: any) {
            return ("0" + dec.toString(16)).substr(-2);
        }

        function generateCodeVerifier() {
            const array = new Uint32Array(56 / 2);
            window.crypto.getRandomValues(array);
            return Array.from(array, dec2hex).join("");
        }

        const code_verifier = generateCodeVerifier();
        return code_verifier;
    }

    async generateCodeChallenge(v: any) {
        function sha256(plain: any) {
            // returns promise ArrayBuffer
            const encoder = new TextEncoder();
            const data = encoder.encode(plain);
            return window.crypto.subtle.digest("SHA-256", data);
        }

        function base64urlencode(a: any) {
            let str = "";
            const bytes = new Uint8Array(a);
            const len = bytes.byteLength;
            for (let i = 0; i < len; i++) {
                str += String.fromCharCode(bytes[i]);
            }
            return btoa(str)
                .replace(/\+/g, "-")
                .replace(/\//g, "_")
                .replace(/=+$/, "");
        }

        async function generateCodeChallengeFromVerifier(v: string) {
            const hashed = await sha256(v);
            const base64encoded = base64urlencode(hashed);
            return base64encoded;
        }

        const code_challenge = await generateCodeChallengeFromVerifier(v);
        // this.codePKCE.code_challenge = code_challenge;
        localStorage.setItem(this.storagePKCEKey, JSON.stringify(this.codePKCE));
        const urlIAM = `${this.config.OAUTH_AUTHORIZE_URL}?code_challenge=${code_challenge}&code_challenge_method=${this.config.OAUTH_CODE_CHALLENGE_METHOD}&grant_type=${this.config.OAUTH_GRANT_TYPE}&state=123&client_id=${this.config.OAUTH_CLIENT_ID}&response_type=${this.config.OAUTH_RESPONSE_TYPE}&redirect_uri=${this.config.OAUTH_REDIRECT_URI}&scope=${this.config.OAUTH_SCOPE}`;
        window.open(urlIAM, "_self");
    }

    public refreshTranslations(): Observable<any> {
        return this.http.put(`${this.config.BASEURL_SETTINGS_API}/v1/translation/clear`, this.getHTTPHeader()).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public fetchConfigFromJson(): Observable<any> {
        return this.http.get("./assets/json/config.json", this.getHTTPHeader()).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    // public back(from: string) {
    //     if (this.originalConfigsFlow && this.originalConfigsFlow.length) {
    //         const foundIdx = this.originalConfigsFlow.findIndex((i: any) => i.path === from);
    //         if (foundIdx > 0) {
    //             this.router.navigateByUrl(this.originalConfigsFlow[foundIdx - 1].path);
    //         } else if (foundIdx === 0) {
    //             this.showToast('This is the first step!', 'info');
    //         }
    //     }
    // }

    public showSwal(title: string, text: string, confirm?: boolean, confirmText?: string, close?: boolean, redirect?: string, machineUpdate?: boolean, state?: string, data?: any) {
        let btnColor = getComputedStyle(document.documentElement).getPropertyValue('--palette-success');
        Swal.fire({
            title: `<div class="d-flex flex-column"><span class="mx-auto"></span><span class="help-cta">${title}</span></div>`,
            html: text,
            showConfirmButton: confirm,
            confirmButtonColor: btnColor,
            confirmButtonText: confirmText,
            allowOutsideClick: false,
            showCloseButton: close,
        }).then((result) => {
            if (result.isConfirmed) {
                if(redirect) {
                    this.router.navigateByUrl(redirect);
                } else if(machineUpdate && state) {
                    this.updateUserState(state, data);
                }
            }
        })
    }

    public getError(error: any) {
        let errorMsg = this.instant('common-generic-error-title');
        if(typeof error === "string") {
            errorMsg = this.instant(error);
        } else if (error?.error?.details?.errors[0]?.errors[0]?.error) {
          const e = error?.error?.details?.errors[0]?.errors[0]?.error;
          errorMsg = this.instant(e);
        } else if (error?.error?.detail === "message.order.error.alt-journey-error") {
            this.showUncheckedIdSwal()
        } else if (!error?.error?.error && error?.error?.reason) {
          errorMsg = error?.error?.reason;
        } else if (error?.error?.error) {
          const e = error?.error?.error.replaceAll('.', '-');
          errorMsg = this.instant(e);
        } else if (
          !error?.error?.error &&
          !error?.error?.reason &&
          error.status
        ) {
          switch (error.status) {
            case 400:
            case 401:
            case 404:
            case 408:
            case 422:
            case 500:
              errorMsg = this.instant('common-error-' + error.status);
              break;
            default:
              errorMsg = this.instant('message-account-error-generic');
          }
        }
        return errorMsg;
        // if (error && typeof error === 'string') {
        //     errorMsg = error;
        // } else if (error && error.error && error.error.error && typeof error.error.error === "string") {
        //     errorMsg = error.error.error;
        // } else if (error.error && error.error.message) {
        //     errorMsg = error.error.message;
        // } else if (error.error && error.error[0] && error.error[0].detail) {
        //     errorMsg = error.error[0].detail;
        // }
        // return errorMsg;
    }

    public showToast(message: string, type = 'success', redirectURL = '', undoUserState = false) {
        let textColor = '';
        let backgroundColor = '';
        let icon = '';
        let closeButton = false;
        let timer = 3000;
        switch (type) {
            case 'success':
                textColor = getComputedStyle(document.documentElement).getPropertyValue('--palette-white');
                backgroundColor = getComputedStyle(document.documentElement).getPropertyValue('--palette-success');
                icon = '<span class="icp-success"></span>';
                break;
            case 'info':
                textColor = getComputedStyle(document.documentElement).getPropertyValue('--palette-white');
                backgroundColor = getComputedStyle(document.documentElement).getPropertyValue('--palette-grey');
                icon = '<span class="icp-info"></span>';
                break;
            case 'danger':
                textColor = getComputedStyle(document.documentElement).getPropertyValue('--palette-white');
                backgroundColor = getComputedStyle(document.documentElement).getPropertyValue('--palette-error-dark');
                icon = '<span class="icp-error"></span>';
                break;
        }
        const Toast = Swal.mixin({
            toast: true,
            color: textColor,
            background: backgroundColor,
            position: 'center',
            iconColor: textColor,
            customClass: {
                popup: 'toast-success',
                icon: 'border-0'
            },
            showConfirmButton: false,
            showCloseButton: closeButton,
            timer: timer,
            timerProgressBar: false,

            willClose: () => {
                if (redirectURL) {
                    this.router.navigateByUrl(redirectURL);
                } else if(undoUserState) {
                    this.undoUserState();
                }
            }
        })
        Toast.fire({
            iconHtml: icon,
            title: message
        })
    }

    public getFieldInfo(results: any, type: any, attr = 'long_name') {
        let ret = '';
        let found = null;
        for (const t of type) {
            found = results.address_components.filter((a: any) => a.types.includes(t))[0];
            if (found) {
                ret = found[attr];
                return ret;
            } else {
                ret = '';
            }
        }
        return ret;
    }

    public decodeObject(obj: any) {
        let objDecoded = JSON.parse(decodeURIComponent(JSON.stringify(obj)));
        return objDecoded;
    }

    public encodeObject(obj: any) {
        let objDecoded = JSON.parse(encodeURIComponent(JSON.stringify(obj)));
        return objDecoded;
    }

    public downloadFileFromBase64(byteCharacters: any, filename: string) {
        const link = document.createElement('a');
        link.href = byteCharacters;
        link.download = filename;
        link.click();
    }

    public downloadFileFromPDF(fileRes: any, fileName: any): void {
        const blob = new Blob([fileRes], { type: 'application/pdf' });
        if (blob.size !== 0) {
            const file: any = {};
            file.nomeFile = fileName
            file.urlFile = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = file.urlFile;
            link.download = file.nomeFile;
            link.click();
            // window.open(link.href);
        }
    }

    public replaceChars(str: any, charsToDelete = ["'", ",", "."]) {
        for (const c of charsToDelete) {
            if (str.includes(c)) {
                str = str.replaceAll(c, "");
            }
        }
        str = str.replaceAll(" ", "-");
        return str;
    }

    public deleteSettings(key: any): Observable<any> {
        key = encodeURIComponent(key);
        return this.http.delete(`${this.config.BASEURL_SETTINGS_API}/v1/secured/settings/keys?key=${key}`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return throwError(error);
            })
        )
    }

    public getSettings(key: any): Observable<any> {
        key = encodeURIComponent(key);
        return this.http.get(`${this.config.BASEURL_SETTINGS_API}/v1/settings?key=${key}`, this.getHTTPHeader(false)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return throwError(error);
            })
        )
    }

    public getSettingsKeys(): Observable<any> {
        return this.http.get(`${this.config.BASEURL_SETTINGS_API}/v1/secured/settings/keys`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return throwError(error);
            })
        )
    }

    public sortList(list: any, sorter: string) {
        return list.sort((a: any, b: any) => (a[sorter] > b[sorter]) ? 1 : ((b[sorter] > a[sorter]) ? -1 : 0));
    }

    public setListFromLoco(res: any, prefix: string) {
        let array = [];
        for (const key of Object.keys(res)) {
            if (key.includes(prefix)) {
                array.push(
                    {
                        value: key.replace(prefix, ''),
                        label: res[key]
                    }
                );
            }
        }
        if (array.length) {
            array = this.sortList(array, "label");
        }
        return array;
    }

    public calculateDiscountNumber(discount: any) {
        if ((discount && String(discount).includes("NaN")) || !discount || discount === "" || discount === 0.0) {
            discount = undefined;
        } else {
            discount = Math.round(discount * 100);
            return discount;
        }
    }

    public applyTheme(theme: any) {
        if (theme.textOnPrimaryColor)   {document.documentElement.style.setProperty(`--palette-text-on-primary`, theme.textOnPrimaryColor && theme.textOnPrimaryColor == 'dark' ? '#212529' : '#FFFFFF')}
        if (theme.textOnSecondaryColor) {document.documentElement.style.setProperty(`--palette-text-on-secondary`, theme.textOnSecondaryColor && theme.textOnSecondaryColor == 'dark' ? '#212529' : '#FFFFFF')}
        if (theme.successColor)         {document.documentElement.style.setProperty(`--palette-success`, theme.successColor)}
        if (theme.warningColor)         {document.documentElement.style.setProperty(`--palette-warning`, theme.warningColor)}
        if (theme.errorColor)         {document.documentElement.style.setProperty(`--palette-error`, theme.errorColor)}
        if (theme.primaryColor)         {document.documentElement.style.setProperty(`--palette-primary`, theme.primaryColor)}
        if (theme.primaryDarkColor)     {document.documentElement.style.setProperty(`--palette-primary-dark`, theme.primaryDarkColor)}
        if (theme.primaryLightColor)     {document.documentElement.style.setProperty(`--palette-primary-dark`, theme.primaryLightColor)}
        if (theme.secondaryColor)       {document.documentElement.style.setProperty(`--palette-secondary`, theme.secondaryColor)}
        if (theme.secondaryDarkColor)   {document.documentElement.style.setProperty(`--palette-secondary-dark`, theme.secondaryDarkColor)}
        if (theme.secondaryLightColor)   {document.documentElement.style.setProperty(`--palette-secondary-light`, theme.secondaryLightColor)}
        if (theme.tertiaryColor)        {document.documentElement.style.setProperty(`--palette-tertiary`, theme.tertiaryColor)}
        if (theme.logoPositive)         {document.documentElement.style.setProperty('--logo-positive', `url('${theme.logoPositive}')`)}
        if (theme.logoNegative)         {document.documentElement.style.setProperty('--logo-negative', `url('${theme.logoNegative}')`)}
        if (theme.brandImage)           {document.documentElement.style.setProperty('--brand-image', `url('${theme.brandImage}')`)}
        if (theme.homeHeaderBg)           {document.documentElement.style.setProperty('--home-header-bg', `url('${theme.homeHeaderBg}')`)}
        if (theme.noTicketsBg)           {document.documentElement.style.setProperty('--no-tickets-image', `url('${theme.noTicketsBg}')`)}
        if (theme.noServicesBg)           {document.documentElement.style.setProperty('--icon-no-services', `url('${theme.noServicesBg}')`)}
        if (theme.maintenanceImage)           {document.documentElement.style.setProperty('--maintenance-image', `url('${theme.maintenanceImage}')`)}
        if (theme.iconAccount)          {document.documentElement.style.setProperty('--icon-account', `url('${theme.iconAccount}')`)}
        if (theme.iconClose)            {document.documentElement.style.setProperty('--icon-close', `url('${theme.iconClose}')`)}
        if (theme.iconCloseNegative)            {document.documentElement.style.setProperty('--icon-close-negative', `url('${theme.iconCloseNegative}')`)}
        if (theme.iconArrowBackLight)   {document.documentElement.style.setProperty('--icon-arrow-back-light', `url('${theme.iconArrowBackLight}')`)}
        if (theme.iconArrowBackDark)    {document.documentElement.style.setProperty('--icon-arrow-back-dark', `url('${theme.iconArrowBackDark}')`)}
        if (theme.iconAttachment)       {document.documentElement.style.setProperty('--icon-attachment', `url('${theme.iconAttachment}')`)}
        if (theme.iconDelete)       {document.documentElement.style.setProperty('--icon-attachment', `url('${theme.iconDelete}')`)}
        if (theme.iconSearch)       {document.documentElement.style.setProperty('--icon-search', `url('${theme.iconSearch}')`)}
        if (theme.iconInfo)       {document.documentElement.style.setProperty('--icon-info', `url('${theme.iconInfo}')`)}
        if (theme.iconCarDefault)       {document.documentElement.style.setProperty('--icon-car-default', `url('${theme.iconCarDefault}')`)}
        if (theme.iconCarOk)            {document.documentElement.style.setProperty('--icon-car-ok', `url('${theme.iconCarOk}')`)}
        if (theme.iconCarAlert)         {document.documentElement.style.setProperty('--icon-car-alert', `url('${theme.iconCarAlert}')`)}
        if (theme.iconCarExpired)         {document.documentElement.style.setProperty('--icon-car-expired', `url('${theme.iconCarAlert}')`)}
        if (theme.iconCarExpired)         {document.documentElement.style.setProperty('--icon-car-expired', `url('${theme.iconCarExpired}')`)}
        if (theme.iconCarWarning)         {document.documentElement.style.setProperty('--icon-car-warning', `url('${theme.iconCarWarning}')`)}
        if (theme.iconCarProgress)      {document.documentElement.style.setProperty('--icon-car-progress', `url('${theme.iconCarProgress}')`)}
        if (theme.iconDocument)         {document.documentElement.style.setProperty('--icon-document', `url('${theme.iconDocument}')`)}
        if (theme.iconAddress)          {document.documentElement.style.setProperty('--icon-address', `url('${theme.iconAddress}')`)}
        if (theme.iconEnvelope)         {document.documentElement.style.setProperty('--icon-envelope', `url('${theme.iconEnvelope}')`)}
        if (theme.iconHide)             {document.documentElement.style.setProperty('--icon-hide', `url('${theme.iconHide}')`)}
        if (theme.iconNotification)     {document.documentElement.style.setProperty('--icon-notification', `url('${theme.iconNotification}')`)}
        if (theme.iconNotificationNew)  {document.documentElement.style.setProperty('--icon-notification-new', `url('${theme.iconNotificationNew}')`)}
        if (theme.iconSend)             {document.documentElement.style.setProperty('--icon-send', `url('${theme.iconSend}')`)}
        if (theme.iconShow)             {document.documentElement.style.setProperty('--icon-show', `url('${theme.iconShow}')`)}
        if (theme.iconSmartphone)       {document.documentElement.style.setProperty('--icon-smartphone', `url('${theme.iconSmartphone}')`)}
        if (theme.iconSupport)          {document.documentElement.style.setProperty('--icon-support', `url('${theme.iconSupport}')`)}
        if (theme.iconConsumer)          {document.documentElement.style.setProperty('--icon-consumer', `url('${theme.iconConsumer}')`)}
        if (theme.iconSmallBusiness)          {document.documentElement.style.setProperty('--icon-small-business', `url('${theme.iconSmallBusiness}')`)}
        if (theme.iconLargeBusiness)          {document.documentElement.style.setProperty('--icon-large-business', `url('${theme.iconLargeBusiness}')`)}
        if (theme.iconPencil)          {document.documentElement.style.setProperty('--icon-pencil', `url('${theme.iconPencil}')`)}
        if (theme.iconIndividualCompanyClicked) {document.documentElement.style.setProperty('--icon-individual-company-clicked', `url('${theme.iconIndividualCompanyClicked}')`)}
        if (theme.iconBigCompanyClicked)        {document.documentElement.style.setProperty('--icon-big-company-clicked', `url('${theme.iconBigCompanyClicked}')`)}
        if (theme.iconCustomerClicked)          {document.documentElement.style.setProperty('--icon-customer-clicked', `url('${theme.iconCustomerClicked}')`)}
        if (theme.iconPasswordLowercase)          {document.documentElement.style.setProperty('--password-lowercase', `url('${theme.iconPasswordLowercase}')`)}
        if (theme.iconPasswordUppercase)          {document.documentElement.style.setProperty('--password-uppercase', `url('${theme.iconPasswordUppercase}')`)}
        if (theme.iconPasswordNumbers)          {document.documentElement.style.setProperty('--password-numbers', `url('${theme.iconPasswordNumbers}')`)}
        if (theme.iconPasswordSpecial)          {document.documentElement.style.setProperty('--password-special', `url('${theme.iconPasswordSpecial}')`)}
        if (theme.iconPasswordRequired)          {document.documentElement.style.setProperty('--password-required', `url('${theme.iconPasswordRequired}')`)}
        if (theme.iconPasswordLowercaseChecked)          {document.documentElement.style.setProperty('--password-lowercase-checked', `url('${theme.iconPasswordLowercaseChecked}')`)}
        if (theme.iconPasswordUppercaseChecked)          {document.documentElement.style.setProperty('--password-uppercase-checked', `url('${theme.iconPasswordUppercaseChecked}')`)}
        if (theme.iconPasswordNumbersChecked)          {document.documentElement.style.setProperty('--password-numbers-checked', `url('${theme.iconPasswordNumbersChecked}')`)}
        if (theme.iconPasswordSpecialChecked)          {document.documentElement.style.setProperty('--password-special-checked', `url('${theme.iconPasswordSpecialChecked}')`)}
        if (theme.iconPasswordRequiredChecked)          {document.documentElement.style.setProperty('--password-required-checked', `url('${theme.iconPasswordRequiredChecked}')`)}

        if (theme.fontRegular) {
            let style = document.createElement('style');
            style.innerText = "@font-face { font-family: 'Brand Rg'; src: url('" + theme.fontRegular + "') format('woff'); font-weight: normal; font-display: swap; }";
            document.head.appendChild(style);
        }
        if (theme.fontBold) {
            let style = document.createElement('style');
            style.innerText = "@font-face { font-family: 'Brand Rg'; src: url('" + theme.fontBold + "') format('woff'); font-weight: bold; font-display: swap; }";
            document.head.appendChild(style);
        }
        // alternatives that do not have default value
        if (!theme.fontRegular) {
            let style = document.createElement('style');
            style.innerText = "@font-face { font-family: 'Brand Rg'; src: url('" + './assets/fonts/VodafoneRg-Regular.ttf' + "') format('woff'); font-weight: regular; font-display: swap; }";
            document.head.appendChild(style);
        }
        if (!theme.fontBold) {
            let style = document.createElement('style');
            style.innerText = "@font-face { font-family: 'Brand Rg'; src: url('" + './assets/fonts/VodafoneRg-Bold.ttf' + "') format('woff'); font-weight: bold; font-display: swap; }";
            document.head.appendChild(style);
        }
        if (theme.iconFavicon) {
            let link: any = document.querySelector("link[rel~='icon']");
            if (link) {
                link['href'] = theme.iconFavicon;
            }
        }
    }

    public applyThemeDefault() {
        let styleRegular = document.createElement('style');
        styleRegular.innerText = "@font-face { font-family: 'Brand Rg'; src: url('" + './assets/fonts/VodafoneRg-Regular.ttf' + "') format('woff'); font-display: swap; }";
        document.head.appendChild(styleRegular);
        let styleBold = document.createElement('style');
        styleBold.innerText = "@font-face { font-family: 'Brand Rg'; src: url('" + './assets/fonts/VodafoneRg-Bold.ttf' + "') format('woff'); font-weight: bold; font-display: swap; }";
        document.head.appendChild(styleBold);
    }

    public showErrorForm(form: any) {
        let totalErrors = 0;
        Object.keys(form.controls).forEach(key => {
            const controlErrors: ValidationErrors = form.get(key).errors;
            if (controlErrors != null) {
                totalErrors++;
                Object.keys(controlErrors).forEach(keyError => {
                    console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
                });
            }
        });

    }

    public urlVerifyModal(name: string, content: string){
        let data;
        let url = '';
        let isImage = false;
        let tmpArray = name.split('.');
        let extension = tmpArray[tmpArray.length - 1];
        if(extension === 'pdf'){
            url = 'data:application/octet;base64,' + content;
        } else if(extension === 'jpg' || extension === 'jpeg' || extension === 'png'){
            url = `data:image/${extension};base64,` + content;
            isImage = true;
        } else{
            extension = 'not allowed';
            url = 'data:application/octet;base64,' + content;
        }
        return data = {
            url: url,
            name: name,
            extension: extension,
            isImage: isImage
        }
    }


    // public downloadFilePdf(url: string) {
    //     return this.http.get(`${url}`, this.getHTTPHeaderPDF(true)).pipe(
    //         map((res: any) => {
    //             return res;
    //         }),
    //         catchError(error => {
    //             return this.handleError(error);
    //         })
    //     )
    // }

    get maintenanceMessage(): any {
        return sessionStorage.getItem(this.storageMaintenanceMessageKey);
    }

    public getMaintenanceTranslation(body: any) {
        return this.http.post(this.config.MAINTENANCE_WINDOW_API_URL, body, this.getHTTPHeader()).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public consoleLogOnMobile(div: any, text: string) {
        const divEl = document.querySelector(div);
        const spanEl = document.createElement("span");
        spanEl.innerHTML = text;
        divEl.appendChild(spanEl);
    }

    public isLogged(): boolean {
        let canRoute = true;
        if (this.storageAccessToken) {
            canRoute = true;
        } else {
            canRoute = false;
            const msg = this.instant('error-access-denied');
            this.showToast(msg, 'danger', '/core/error/auth-error');
        }
        return canRoute;
    }

    public isSessionLogged(): boolean {
        let canRoute = true;
        if (this.storageSessionAccessToken) {
            canRoute = true;
        } else {
            canRoute = false;
            const msg = this.instant('error-access-denied');
            this.showToast(msg, 'danger', '/core/error/auth-error');
        }
        return canRoute;
    }

    public isSubbable(paymentMethods: any) {
        let ret = {
            subbable: false,
            paymentMethods: []
        };
        let subbable = false;
        let found = paymentMethods.filter((method: any) => method.automatic_renewal);
        if(found && found.length) {
          paymentMethods = found;
          subbable = true;
        }
        ret.subbable = subbable;
        ret.paymentMethods = paymentMethods;
        return ret;
    }

    public eventToImpressum() {
        const footer = document.getElementById("footer");
        if(footer) {
            const impressum = document.querySelector(".impressum");
            if(impressum) {
                impressum.classList.add("cursor-pointer");
                impressum.addEventListener("click", () => {
                    this.dialog.open(ImpressumModal, {disableClose: true, panelClass: 'impressum-dialog-container'});
                });
            }
        }
    }
}
